jQuery($ => {
    class DetachedTabs {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._tabs      = this._element.find('.m-detached-tabs__tab');
        this._indicator = this._element.find('.m-detached-tabs__indicator');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on( 'transition', (_, index) => this.transitionTabs(index) );
      }

      transitionTabs = (index) => {
        const activeTab = this._tabs.filter('.m-detached-tabs__tab--active');
        let nextTab;
        if (index !== undefined) {
          activeTab.removeClass('m-detached-tabs__tab--active');
          nextTab = this._tabs.filter(`[data-tab-index="${index}"]`);
          nextTab.addClass('m-detached-tabs__tab--active');
        } else {
          nextTab = activeTab;
        }

        if (window.innerWidth > 768) {
          const nextTabTop = $(nextTab).position().top;
          const nextTabHeight = parseInt($(nextTab).css('height'));
          const indicatorHeight = parseInt(this._indicator.css('height'));
          this._indicator.css('top', nextTabTop + (nextTabHeight / 2) - (indicatorHeight / 2));
          this._indicator.css('left', 0);
        } else {
          const nextTabTop = $(nextTab).position().top;
          const nextTabLeft = $(nextTab).position().left;
          const nextTabWidth = parseInt($(nextTab).css('width'));
          const nextTabHeight = parseInt($(nextTab).css('height'));
          const indicatorWidth = parseInt(this._indicator.css('width'));
          this._indicator.css('left', nextTabLeft + (nextTabWidth / 2) - (indicatorWidth / 2));
          this._indicator.css('top', nextTabTop + nextTabHeight);
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.detached_tabs = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].detached_tabs = new DetachedTabs(_[i], opt);
        else
          ret = _[i].detached_tabs[opt].apply(_[i].detached_tabs, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-detached-tabs').detached_tabs();
});